export default __webpack_public_path__ + "static/media/view.55297f31.svg";